<template>
  <header v-if="data.sc_medias" id="header" class="flex">
    <div class="flex flex-col profile-box">
      <figure>
        <img
          src="https://avatars.githubusercontent.com/u/55255414?v=4"
          alt="profile"
        />
      </figure>
      <div class="details">
        <h2>{{ data.name }}</h2>
        <h3>{{ data.profession }}</h3>
        <ul class="icons flex">
          <li v-for="media in data.sc_medias.slice(0, 3)" :key="media.site">
            <a :href="media.src" class="flex" target="_blank"
              ><i :class="media.site + ' icon'"></i
            ></a>
          </li>
        </ul>
      </div>
      <span class="btn btn-primary" @click="scrollDown">
        {{ "Scroll Down " }}<i class="arrow alternate down icon"></i>
      </span>
    </div>
  </header>
</template>
<script>
export default {
  props: { data: Object, scrollDown: Function },
};
</script>
<style scoped>
header {
  width: 100vw;
  height: 100vh;
  z-index: 3;
  position: relative;
  text-align: center;
  background-color: #fff;
  background-image: -moz-linear-gradient(60deg, var(--primary) 5%, var(--blue));
  background-image: -webkit-linear-gradient(
    60deg,
    var(--primary) 5%,
    var(--blue)
  );
  background-image: var(--gradient);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top left, center center;
  -moz-transition: opacity 0.5s ease-in-out;
  -webkit-transition: opacity 0.5s ease-in-out;
  -ms-transition: opacity 0.5s ease-in-out;
  transition: 0.5s ease-in-out;
}
header .profile-box {
  width: 55%;
  background: var(--light);
  border: none;
  margin: 0 auto;
  padding: 2rem 0;
  border-radius: 5px;
  position: relative;
  z-index: 1;
}
header figure {
  width: 100%;
  display: block;
  margin-bottom: 1rem;
  position: relative;
}
header figure::before {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  width: 100%;
  height: 1px;
  z-index: -1;
  background: #c8cccf;
}
header img {
  width: 175px;
  height: 175px;
  margin: 0 1rem;
  border-radius: 100%;
  box-shadow: 0 0 0 1.5em var(--light);
}
header .details {
  margin: 1rem 0;
}
header h2,
header h3 {
  text-align: center;
  line-height: 1.5;
  letter-spacing: 0.22em;
  word-spacing: 0.35em;
  text-transform: uppercase;
  margin: 1rem 0;
}
header h2 {
  font-size: 1.5em;
}
header ul.flex {
  list-style: none;
  flex-direction: row;
}
header li {
  margin: 0 1rem;
}
header li i.icon {
  color: var(--primary);
  padding: 1rem;
  font-size: 2.5rem;
  border: 2px solid var(--primary);
  border-radius: 50%;
  width: auto;
  height: auto;
}
@media screen and (max-width: 500px) {
  header .profile-box {
    width: 75%;
    padding: 2rem 0;
  }
  header img {
    width: 96px;
    height: 96px;
    margin: 0 1rem;
    box-shadow: 0 0 0 0.9em var(--light);
  }
  header h2 {
    font-size: 1.2em;
  }
  header h3 {
    font-size: 0.9em;
  }
  header li {
    margin: 0 0.5rem;
  }
  header i.icon {
    padding: 0.5rem;
    font-size: 1.7rem;
  }
  header i.icon.arrow {
    font-size: 1rem;
  }
}
</style>
